import { initNewRelicInterceptor } from './newRelicInterceptor';

let initialized = false;

export const initInterceptors = () => {
  if (initialized) {
    return;
  }

  initNewRelicInterceptor();
  initialized = true;
};

export default initInterceptors;



// WEBPACK FOOTER //
// ./src/requests/interceptors/index.js